<!-- Mail Detail Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="onBackdropClick($event)">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas fa-envelope me-2"></i>
        {{ 'MAIL_POPUP.TITLE' | translate }}
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <!-- Selected Waybills Section -->
      <div class="detail-section">
        <h5 class="section-title">
          <i class="fas fa-list me-2"></i>
          <span *ngIf="isMailPerWaybill">{{ 'MAIL_POPUP.SELECTED_WAYBILLS' | translate }}</span>
          <span *ngIf="!isMailPerWaybill">{{ 'MAIL_POPUP.SELECTED_TOURS' | translate }}</span>
          <span class="badge bg-primary ms-2" *ngIf="isMailPerWaybill">{{ localWaybillCodes.length }}</span>
          <span class="badge bg-primary ms-2" *ngIf="!isMailPerWaybill">{{ routingData.length }}</span>
        </h5>
        
        <!-- Mail Type Toggle -->
        <div class="mail-type-toggle mb-3">
          <div class="toggle-container">
            <div class="toggle-option" [class.active]="isMailPerWaybill" (click)="setMailType(true)">
              <i class="fas fa-file-invoice me-2"></i>
              {{ 'MAIL_POPUP.MAIL_PER_WAYBILL' | translate }}
            </div>
            <div class="toggle-option" [class.active]="!isMailPerWaybill" (click)="setMailType(false)">
              <i class="fas fa-route me-2"></i>
              {{ 'MAIL_POPUP.MAIL_PER_ROUTING' | translate }}
            </div>
          </div>
        </div>
        
        <!-- Waybills List (for "Invia Singola Bolla") -->
        <div class="waybills-container" *ngIf="localWaybillCodes.length > 0 && isMailPerWaybill">
          <div class="waybill-item" *ngFor="let waybillCode of localWaybillCodes; trackBy: trackByWaybillCode">
            <!-- Main row with all elements inline -->
            <div class="waybill-main-row">
              <div class="waybill-info">
                <i class="fas fa-file-invoice me-2"></i>
                <span class="waybill-code">{{ waybillCode }}</span>
              </div>
              <div class="item-actions">
                <button 
                  type="button" 
                  class="btn-mail"
                  (click)="toggleItemEmails(waybillCode); $event.stopPropagation();"
                  [title]="'Gestisci email per questa bolla'">
                  <i class="fas fa-at"></i>
                  <span class="badge bg-primary text-white ms-1">{{ getItemEmails(waybillCode).length }}</span>
                </button>
                <button 
                  type="button" 
                  class="btn-remove"
                  (click)="removeWaybill(waybillCode); $event.stopPropagation();"
                  [title]="'MAIL_POPUP.REMOVE' | translate">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            
            <!-- Email management section for this waybill -->
            <div class="item-emails-section" *ngIf="isItemEmailExpanded(waybillCode)">
              <div class="item-emails-header">
                <h6 class="emails-title">
                  <i class="fas fa-envelope me-2"></i>
                  Email per {{ waybillCode }}
                </h6>
              </div>
              
              <!-- Add new email input -->
              <div class="email-input-section mb-2">
                <div class="input-group input-group-sm">
                  <input 
                    type="email" 
                    class="form-control email-input" 
                    [value]="getNewEmailInput(waybillCode)"
                    (input)="setNewEmailInput(waybillCode, $any($event.target).value)"
                    (keypress)="onItemEmailKeyPress($event, waybillCode)"
                    placeholder="Inserisci indirizzo email"
                    [class.is-invalid]="getNewEmailInput(waybillCode) && !isValidEmail(getNewEmailInput(waybillCode))">
                  <button 
                    type="button" 
                    class="btn btn-add-email" 
                    (click)="addEmailToItem(waybillCode)"
                    [disabled]="!getNewEmailInput(waybillCode).trim() || !isValidEmail(getNewEmailInput(waybillCode).trim())"
                    [title]="'Aggiungi email'">
                    <i class="fas fa-plus"></i>
                    <span class="btn-text">Aggiungi</span>
                  </button>
                </div>
              </div>

              <!-- Loading state -->
              <div class="loading-emails" *ngIf="isItemEmailsLoading(waybillCode)">
                <i class="fas fa-spinner fa-spin text-primary"></i>
                <span class="ms-2">Caricamento...</span>
              </div>

              <!-- Emails list -->
              <div class="item-emails-list" *ngIf="!isItemEmailsLoading(waybillCode)">
                <div class="email-item-small" *ngFor="let email of getItemEmails(waybillCode); trackBy: trackByEmail">
                  <span class="email-text">{{ email }}</span>
                  <button 
                    type="button" 
                    class="btn-remove-small"
                    (click)="removeEmailFromItem(waybillCode, email)"
                    [title]="'Rimuovi email'">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                
                <div class="no-emails" *ngIf="getItemEmails(waybillCode).length === 0 && !isItemEmailsLoading(waybillCode)">
                  <span class="text-muted">Nessuna email configurata</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Routing List (for "Invia Intero Instradamento") -->
        <div class="waybills-container" *ngIf="routingData.length > 0 && !isMailPerWaybill">
          <div class="waybill-item" *ngFor="let routing of routingData; trackBy: trackByRoutingCode">
            <!-- Main row with all elements inline -->
            <div class="waybill-main-row">
              <div class="waybill-info">
                <i class="fas fa-route me-2"></i>
                <span class="waybill-code">{{ routing.routingCode }}</span>
              </div>
              <div class="routing-date-column">
                {{ routing.routingDate | date:'dd/MM/yyyy' }}
              </div>
              <div class="item-actions">
                <button 
                  type="button" 
                  class="btn-mail"
                  (click)="toggleItemEmails(routing.routingCode); $event.stopPropagation();"
                  [title]="'Gestisci email per questo instradamento'">
                  <i class="fas fa-at"></i>
                  <span class="badge bg-primary text-white ms-1">{{ getItemEmails(routing.routingCode).length }}</span>
                </button>
                <button 
                  type="button" 
                  class="btn-remove"
                  (click)="removeRouting(routing.routingCode); $event.stopPropagation();"
                  [title]="'MAIL_POPUP.REMOVE' | translate">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            
            <!-- Email management section for this routing -->
            <div class="item-emails-section" *ngIf="isItemEmailExpanded(routing.routingCode)">
              <div class="item-emails-header">
                <h6 class="emails-title">
                  <i class="fas fa-envelope me-2"></i>
                  Email per {{ routing.routingCode }}
                </h6>
              </div>
              
              <!-- Add new email input -->
              <div class="email-input-section mb-2">
                <div class="input-group input-group-sm">
                  <input 
                    type="email" 
                    class="form-control email-input" 
                    [value]="getNewEmailInput(routing.routingCode)"
                    (input)="setNewEmailInput(routing.routingCode, $any($event.target).value)"
                    (keypress)="onItemEmailKeyPress($event, routing.routingCode)"
                    placeholder="Inserisci indirizzo email"
                    [class.is-invalid]="getNewEmailInput(routing.routingCode) && !isValidEmail(getNewEmailInput(routing.routingCode))">
                  <button 
                    type="button" 
                    class="btn btn-add-email" 
                    (click)="addEmailToItem(routing.routingCode)"
                    [disabled]="!getNewEmailInput(routing.routingCode).trim() || !isValidEmail(getNewEmailInput(routing.routingCode).trim())"
                    [title]="'Aggiungi email'">
                    <i class="fas fa-plus"></i>
                    <span class="btn-text">Aggiungi</span>
                  </button>
                </div>
              </div>

              <!-- Loading state -->
              <div class="loading-emails" *ngIf="isItemEmailsLoading(routing.routingCode)">
                <i class="fas fa-spinner fa-spin text-primary"></i>
                <span class="ms-2">Caricamento...</span>
              </div>

              <!-- Emails list -->
              <div class="item-emails-list" *ngIf="!isItemEmailsLoading(routing.routingCode)">
                <div class="email-item-small" *ngFor="let email of getItemEmails(routing.routingCode); trackBy: trackByEmail">
                  <span class="email-text">{{ email }}</span>
                  <button 
                    type="button" 
                    class="btn-remove-small"
                    (click)="removeEmailFromItem(routing.routingCode, email)"
                    [title]="'Rimuovi email'">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                
                <div class="no-emails" *ngIf="getItemEmails(routing.routingCode).length === 0 && !isItemEmailsLoading(routing.routingCode)">
                  <span class="text-muted">Nessuna email configurata</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="empty-state" *ngIf="(isMailPerWaybill && localWaybillCodes.length === 0) || (!isMailPerWaybill && routingData.length === 0)">
          <i class="fas fa-exclamation-triangle text-warning"></i>
          <p class="mb-0">{{ 'MAIL_POPUP.NO_WAYBILLS_SELECTED' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <button type="button" class="btn btn-secondary me-2" (click)="close()">
        <i class="fas fa-times me-2"></i>
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="onConfirm()"
        [disabled]="(isMailPerWaybill && localWaybillCodes.length === 0) || (!isMailPerWaybill && routingData.length === 0) || isSending">
        <i [class]="isSending ? 'fas fa-spinner fa-spin me-2' : 'fas fa-envelope me-2'"></i>
        {{ (isSending ? 'MAIL_POPUP.SENDING' : 'MAIL_POPUP.SEND_BY_MAIL') | translate }}
      </button>
    </div>
  </div>
</div>
